var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"pd-VendorSide_GoogleStaticMap",attrs:{"src":_vm.googleMapsSrc,"border":"0"}})}
var staticRenderFns = []

export { render, staticRenderFns }